import React from "react";
import { Route, Navigate } from "react-router-dom";
import Protected from "../components/Protected";
import AdminProtected from "../components/AdminProtected";
import SettingsUsers from "../pages/Admin-pages/SettingsPages/SettingsUsers";
import NewUsers from "../pages/Admin-pages/SettingsPages/NewUsers";
import EditUsers from "../pages/Admin-pages/SettingsPages/EditUsers";
import MainAccess from "../pages/Admin-pages/SettingsPages/MainAccess";
import ModuleRoles from "../pages/Admin-pages/clientPages/ModuleRoles";
import ModuleRolesAdd from "../pages/Admin-pages/clientPages/ModuleRolesAdd";
import ModuleRolesEdit from "../pages/Admin-pages/clientPages/ModuleRolesEdit";
import MainAccessOrgEdit from "../pages/Admin-pages/SettingsPages/MainAccessOrgEdit";
import MainAccessUserEdit from "../pages/Admin-pages/SettingsPages/MainAccessUserEdit";
import { useSelector } from "react-redux";
import {
  getUpdateStatus2,
  getViewStatus2,
} from "../components/AdminComponents/ViewUpdateIndexTnAdmin";
import TnViewNotifications from "../pages/Admin-pages/CA-admin-pages/Communications/TnViewNotifications";
import CustomNotifications from "../pages/Admin-pages/CA-admin-pages/Communications/CustomNotifications";
import CustomNotificationsListing from "../pages/Admin-pages/CA-admin-pages/Communications/CustomNotificationsListing";
import CustomNotificationsEdit from "../pages/Admin-pages/CA-admin-pages/Communications/CustomNotificationsEdit";
import CustomNotificationsLogs from "../pages/Admin-pages/CA-admin-pages/Communications/CustomNotificationsLogs";
const SettingRoutes = () => {
  const userInfo = useSelector((state) => state?.user);
  const notificationRedirect = getViewStatus2(userInfo, 3, 0)
    ? "/access-manager/notifications/view-notifications/"
    : "/access-manager/notifications/custom-notifications/";
  const routes = [
    <Route
      key="setting-route-1"
      path="/access-manager/admins"
      element={
        <Protected>
          <AdminProtected access={getViewStatus2(userInfo, 0, 0)}>
            <SettingsUsers />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="setting-route-3"
      path="/access-manager/admins/add-user"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus2(userInfo, 0, 0)}>
            <NewUsers />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="setting-route-5"
      path="/access-manager/admins/edit-user/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus2(userInfo, 0, 0)}>
            <EditUsers />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="setting-route-6"
      path="/access-manager/access-rename"
      element={
        <Protected>
          <AdminProtected access={getViewStatus2(userInfo, 2, 0)}>
            <MainAccess />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-11"
      path="/access-manager/roles/"
      element={
        <Protected>
          <AdminProtected access={getViewStatus2(userInfo, 1, 0)}>
            <ModuleRoles />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="setting-route-4"
      path="/access-manager/notifications/"
      element={<Navigate to={notificationRedirect} />}
    />,
    <Route
      key="setting-route--latest--1"
      path="/access-manager/notifications/view-notifications/:id?"
      element={
        <Protected>
          <AdminProtected access={getViewStatus2(userInfo, 3, 0)}>
            <TnViewNotifications />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-24"
      path="/access-manager/roles/add-role"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus2(userInfo, 1, 0)}>
            <ModuleRolesAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-25"
      path="/access-manager/roles/edit-role/:id"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus2(userInfo, 1, 0)}>
            <ModuleRolesEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-edit-01"
      path="/access-manager/access-rename/edit-org"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus2(userInfo, 2, 0)}>
            <MainAccessOrgEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-edit-02"
      path="/access-manager/access-rename/edit-user"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus2(userInfo, 2, 0)}>
            <MainAccessUserEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="setting-route-4"
      path="/access-manager"
      element={<Navigate to="/access-manager/admins" />}
    />,
    <Route
      key="manager-route-edit-0232"
      path="/access-manager/notifications/custom-notifications/add"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomNotifications />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-edit-0232"
      path="/access-manager/notifications/custom-notifications"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomNotificationsListing />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-edit-0232-098"
      path="/access-manager/notifications/custom-notifications/edit/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomNotificationsEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-edit-0232-098322"
      path="/access-manager/notifications/custom-notifications/logs/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomNotificationsLogs />
          </AdminProtected>
        </Protected>
      }
    />,
  ];
  return routes;
};
export default SettingRoutes;
